import { render } from "./KindergartenPage.vue?vue&type=template&id=03346155"
import script from "./KindergartenPage.vue?vue&type=script&lang=js"
export * from "./KindergartenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__